var App = App || {};

App.WidgetDigital = (function ($) {
    'use strict';

    function Init(widget) {
        Composition(widget);
        $(window).on("resize", function () { Composition(widget) });
        Animate(widget);
        Carousel(widget);
    }

    function Composition(widget) {

        if (widget.is(':last-child')) return;

        widget.addClass("widget-digital-js-last-child");
        const band = widget.find('.widget-digital__ctaBand');
        const bandHeight = band.outerHeight();
        const nextWidget = widget.next('.widget');
        const nextWidgetProp = nextWidget.is('[data-background]') ? 'padding-top' : 'margin-top';

        band.removeAttr('style');
        band.css({ "margin-bottom": bandHeight * -.5 });

        nextWidget.removeAttr('style');
        const nextWidgetDistance = parseFloat(nextWidget.css(nextWidgetProp));
        nextWidget.css(nextWidgetProp, nextWidgetDistance + bandHeight * .5);
    }

    function Animate(widget) {
        const animate = widget.find(".widget-digital__ctaBand");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".component-ctaBand", type: "animate__fadeInUp", stagger: 0 }
            ]
        });
    }

    function Carousel(widget) {

        const carousel = widget.find(".splide");
        const counterCurrent = carousel.find("[data-splide-counter=\"current\"]");
        const counterTotal = carousel.find("[data-splide-counter=\"total\"]");
        const progress = carousel.find("[data-splide-progress]");

        const options = {
            type: 'slide',
            rewind: true,
            speed: 500,
            arrows: true,
            pagination: false,
            label: "Digital Banking Information Carousel"
        }
        const splide = new Splide(carousel[0], options);

        splide.on('move', function (newIndex) {
            counterCurrent.html(newIndex + 1);
            progress.css({ left: `${100 / splide.length * (newIndex)}%` });
        });

        splide.on('mounted', function () {
            counterCurrent.html(splide.index + 1);
            counterTotal.html(splide.length);
            progress.width(`${100 / splide.length}%`);
        });

        splide.mount();

    }

    return {
        Init: Init
    };

})(jQuery);